// extracted by mini-css-extract-plugin
export default {"link":"SidebarLink_link__81hoZ","homeBtn":"SidebarLink_homeBtn__MJnJE"};